import { parseDT0 } from './utils/parseDT0';
import { parseRes } from './utils/parseRes';

export function pelletHardnessParseHitec(dt0, res) {
  const variables = parseDT0(dt0);
  const meta = parseRes(res);
  return { variables, meta };
}
